import { LabelStatus } from '@innovationdepartment/proxima-ui';
import type { DataIngestionViewProps } from 'types/brandCustomer';
import LoadingSpinner from 'ui/LoadingSpinner';
import PageLayoutSectionView from '../../PageSectionLayout.View';

const DataIngestionView = ({
  isFileUploadAllowed,
  brandCustomerSettingsLoading
}: DataIngestionViewProps) => (
  <PageLayoutSectionView
    sections={[
      {
        label: 'Customer lists',
        content: brandCustomerSettingsLoading ? (
          <LoadingSpinner />
        ) : (
          <LabelStatus
            label={isFileUploadAllowed ? 'Enabled' : 'Disabled'}
            variant={isFileUploadAllowed ? 'success' : 'default'}
          />
        )
      }
    ]}
  />
);

export default DataIngestionView;
